import * as Bixby from '$/core';

export abstract class CacheService {
  public static storage(): Storage {
    return Bixby.Configuration && Bixby.Configuration.storage === 'localStorage' ? localStorage : sessionStorage;
  }

  public static get<T>(cacheKey: string): T | null {
    let result: T | null = null;

    // attempt to get the localStorage object
    const cacheJson: string | null = CacheService.storage().getItem(cacheKey);
    if (cacheJson) {
      // if found parse it
      const cacheValue = JSON.parse(cacheJson);

      // check expiry
      if (cacheValue.expiry !== null) {
        const expiry: Date = new Date(cacheValue.expiry);
        if (expiry > new Date()) {
          result = cacheValue.value as T;
        } else {
          CacheService.storage().removeItem(cacheKey);
        }
      } else {
        result = cacheValue.value as T;
      }
    }

    return result;
  }

  public static set(cacheKey: string, val: any, expiryMinutes?: number | null): void {
    const stringified = CacheService.createPersistable(val, expiryMinutes);
    CacheService.storage().setItem(cacheKey, stringified);
  }

  public static async getOrSetAsync<T>(key: string, getter: () => Promise<T>, timeoutMinutes?: number): Promise<T> {
    const cachedResult: T | null = this.get<T>(key);
    if (cachedResult !== null) {
      return cachedResult;
    } else {
      const fetchedResult: T | null = await getter();

      if (fetchedResult !== null) {
        CacheService.set(key, fetchedResult, timeoutMinutes);
      }

      return fetchedResult;
    }
  }

  public static remove(cacheKey: string): void {
    CacheService.storage().removeItem(cacheKey);
  }

  private static createPersistable(val: any, expiryMinutes?: number | null) {
    let expiry: Date | null = null;
    if (expiryMinutes) {
      expiry = new Date();
      expiry.setMinutes(expiry.getMinutes() + expiryMinutes);
    }

    const stringified = JSON.stringify({
      expiry,
      value: val || '',
    });
    return stringified;
  }
}
